import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';

export type PieLegendItem = { name: string; color: string };

/**
 * Shared Overview / Invoicing pie legend. Always pins to the top of the pie.
 * Lists every slice; Overview already folds long tails into Other.
 * Fullscreen uses larger type. Long names ellipsis instead of growing this column.
 */
export function PieChartLegend({
    items,
    isFullscreen,
}: {
    items: PieLegendItem[];
    isFullscreen: boolean;
}) {
    const fontSize = isFullscreen ? 'sm' : 'xs';

    return (
        <Flex direction="column" gap={1.5} flexShrink={1} minW={0} maxW="30%" overflow="hidden" h="100%">
            <Box h="5%" flexShrink={0} />
            <Text
                fontSize={fontSize}
                fontWeight="semibold"
                color="gray.500"
                textTransform="uppercase"
                letterSpacing="wider"
            >
                Legend
            </Text>
            {items.map((entry, i) => (
                <Flex key={`${entry.name}-${i}`} align="center" minW={0} w="100%">
                    <Box w="8px" h="8px" borderRadius="full" bg={entry.color} mr={2} flexShrink={0} />
                    <Tooltip label={entry.name} placement="left" hasArrow openDelay={400}>
                        <Text
                            fontSize={fontSize}
                            color="gray.600"
                            fontWeight="medium"
                            noOfLines={2}
                            minW={0}
                            flex={1}
                        >
                            {entry.name}
                        </Text>
                    </Tooltip>
                </Flex>
            ))}
        </Flex>
    );
}
